module.exports = __webpack_public_path__ + "media/houseandland_blank.a459557b.svg";